import './libs/javascript'
import './libs/stylesheets'

import Vue from 'vue'
import axios from './axios'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import Helper from './plugins/helper'
import Meta from 'vue-meta'
import { i18n } from './locale'
import VueProgressBar from 'vue-progressbar'
import VueCarousel from 'vue-carousel'
import VueFormWizard from 'vue-form-wizard'
import VeeValidate from 'vee-validate'
import VueToastr from '@deveodk/vue-toastr'
import VueSweetalert2 from 'vue-sweetalert2'
import moment from 'moment'
import { VueMaskDirective } from 'v-mask'
import DatePicker from 'vue-bootstrap-datetimepicker'
import Paginate from 'vuejs-paginate'
import loading from 'vuejs-loading-screen'

Vue.component('paginate', Paginate)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$moment = moment
Vue.prototype.$default_page = process.env.VUE_APP_DEFAULT_ROUTE
Vue.prototype.$base_api = process.env.VUE_APP_BASE_URL
Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)
Vue.use(Helper)
Vue.use(Meta)
Vue.use(VueCarousel)
Vue.use(VueSweetalert2)
Vue.use(VueFormWizard)
Vue.use(DatePicker)
Vue.use(loading, {
  bg: '#3f51b5e0',
  icon: 'fas fa-sync-alt',
  size: 3,
  icon_color: 'white'
})
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 4000
})
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields'
})

Vue.directive('mask', VueMaskDirective)

// vue progressbar
const options = {
  color: '#3C56A0',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.3s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}
// window.$ = window.jQuery = require("jquery");
Vue.use(VueProgressBar, options)

new Vue({
  router,
  store,
  i18n,
  render: function (h) { return h(App) }
}).$mount('#app')
